import { render } from "./Chip.vue?vue&type=template&id=1094b9b6"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=1094b9b6&lang=css"
script.render = render

export default script